<template>
  <slot v-if="mounted" />
  <slot v-else name="fallback" />
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';

/**
 * Renders content only after the component has mounted on the client.
 * During SSR, the `fallback` slot is rendered instead.
 *
 * @slot default - Content rendered only on the client (after mount)
 * @slot fallback - Content rendered during SSR / before mount
 */
const mounted = ref(false);

onMounted(() => {
  mounted.value = true;
});
</script>
